import React from 'react'

function SewingRepairInBatchHeader() {
    return (
        <thead className='thead-light SewingRepairInBatchHeader'>
            <tr>
                <th className='Barcode'>Barcode</th>
                <th className='ProductType'>SKU</th>
                <th className='Status'>Trạng thái</th>
                <th className='BatchName'>Tên lô</th>
                <th className='Size'>Size</th>
                <th className='CreatedDate'>Ngày báo lỗi</th>
                <th className='ErrorType'>Loại lỗi</th>
                <th className='Partner'>Đối tác in ép</th>
                <th className='SewingPartner'>Đối tác may</th>
            </tr>
        </thead>
    )
}

export default SewingRepairInBatchHeader